// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"b98882d8","259":"8b3dbd7f","503":"3c7b25c9","553":"33891a23","554":"22522be2","641":"6c220361","716":"44f4df2d","846":"930e8803","904":"b8a5d15f","952":"afe84b69","977":"5fdf86c5"}[chunkId] + ".chunk.js";
};